





















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { ELevel, Menu } from '@/services/Menus'
import { ILevel } from '@/services/Level'
import vueRouter from '@/router'
import * as _ from 'lodash'
import { Getter, Action } from 'vuex-class'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import { ICenter } from '@/store/modules/views/center/states'

@Component
export default class SidebarViewModel extends Vue {

  @Prop({ default: true }) public value!: boolean

  @Getter('components/menuSidebar')
  private menus!: Menu[]

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('components/level')
  private levelGetter!: {
    id?: string,
    mode: string,
  }

  @Getter('center/itemLists')
  private centerItemLists!: ICenter[]

  private mini = this.$vuetify.breakpoint.lgAndUp

  private VUE_APP_BASEURL = process.env.VUE_APP_BASEURL

  private levels: ILevel[] = []

  get level() {
    return this.levelGetter
  }

  set level(level) {
    this.$store.dispatch('components/setLevel', level)
    if (
      this.$router.currentRoute.path.startsWith('/main')
      && !_.find(this.menus, (menu) => menu.route === this.$route.params.page)
    ) {
      this.$router.push('/main/' + _.head(this.menus).route)
    }
  }

  get mode() {
    if (this.level.mode === 'all') {
      return 'ผู้ดูแลระบบ'
    } else if (this.level.mode === 'center') {
      return 'ศูนย์'
    } else {
      return 'ส่วนตัว'
    }
  }

  get logo() {
    return `${this.VUE_APP_BASEURL}/${this.mini ? 'public/favicon.ico' : 'public/favicon.ico'}`
  }

  get drawer() {
    return this.value
  }

  // get levels() {
  //   return _.concat(LEVEL, [{
  //     name: 'ศูนย์บริการ',
  //     value: {id: '333333', mode: 'center'},
  //   }, {
  //     name: 'ศูนย์บริการsdgdg',
  //     value: {id: 'fefsfsdfdsfdsf', mode: 'center'},
  //   }])
  // }

  get levelIcon() {
    if (this.level.mode === 'all') {
      return 'account-child-circle'
    } else if (this.level.mode === 'center') {
      return 'hospital-building'
    } else {
      return 'account'
    }
  }

  // tslint:disable-next-line:adjacent-overload-signatures
  set drawer(val) {
    this.$emit('input', val)
  }

  // get app() {
  //   const app = localStorage.getItem('app')
  //   if (!app) {
  //     this.$router.push('/')
  //   } else {
  //     return app
  //   }
  // }

  @Action('center/getCenterList')
  private getCentertList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => Promise<void>

  @Action('components/setReady')
  private setReady: (isReady: boolean) => void

  @Watch('profile.role.name')
  private async renderMenu(role) {
    await new Promise(async (resolve) => {
      await this.getCentertList({
        headers: {
          page: 1,
          limit: 9999,
          sortBy: 'name',
          sortDesc: false,
          search: Buffer.from('').toString('base64'),
          filter: Buffer.from('{}').toString('base64'),
        },
      })
      resolve(true)
    })
    // this.$store.dispatch('components/setLevel', {id: this.profile._id, mode: ELevel.USER})
    this.levels = [{
      name: 'เมนูส่วนตัว',
      value: {id: this.profile._id, mode: ELevel.USER},
    }]
    if ((role === 'ผู้ดูแลระบบ') || _.some(this.profile.permissions, {level: 'all'})) {
      this.levels = _.concat<ILevel>(
        [{
          name: 'ผู้ดูแลระบบ',
          value: {id: 'all', mode: 'all'},
        }],
        _.map(this.centerItemLists, (center) => {
          return {
            name: center.name,
            value: {id: center._id, mode: ELevel.CENTER},
          }
        }),
        this.levels,
      )
    } else if (_.some(this.profile.permissions, {level: ELevel.CENTER})) {
      this.levels = [{
        name: this.profile.center.name,
        value: {id: this.profile.center._id, mode: ELevel.CENTER},
      }, ...this.levels]
    }
    let levelOld: ILevel['value']
    try {
      levelOld = JSON.parse(localStorage.getItem('level'))
    } catch (e) {
      //
    }
    if (levelOld) {
      const findLevel = _.find(this.levels, (level) => _.isEqual(level.value, levelOld))
      if (findLevel) {
        this.level = findLevel.value
      }
    }
    if (!this.level.id) {
      this.level = {id: this.profile._id, mode: ELevel.USER}
    }
    this.setReady(true)
  }

  private handleChangeLevel() {
    if (this.$router.currentRoute.path.startsWith('/action')) {
      this.$router.push('/main/' + _.head(this.menus).route)
    }
  }

  private async mounted() {
    if (this.profile.role) {
      this.renderMenu(this.profile.role.name)
    }
    // console.log(this.profile)
    // console.log(this.$store.getters['userprofile/getProfile'])
    // if () {

    // }
    // await HttpRequestServiceWithToken.getByLevel
  }

  private handleNavigateToMainPage() {
    const menu = _.head(this.menus)
    const result = menu && menu.route
    if (result) {
      this.$router.push(result)
    }
  }

  private checkActivateMenu(route: string) {
    const name = this.$route.params.page + (this.$route.params.component ? `/${this.$route.params.component}` : '')
    // const name = this.$route.params.tab || this.$route.params.component || this.$route.params.page
    // route = _.chain(route).split('/').last().value()
    return route === name
  }

  private checkIsInSettingMenu() {
    return this.$route.params.tab === 'unsubscribeoption' || this.$route.params.tab === 'domainoption' ? true : false
  }

  private goToRoute(route) {
    const key = 'domain'
    localStorage[key] = ''
    this.$router.push(route)
  }
}
